module.exports = __webpack_public_path__ + "static/media/create-stack.78010a9a.svg";